import { createSlice } from '@reduxjs/toolkit';
import { REDUCER_ADVERT_REVIEW_CHECK_NAME } from '#reviewCheck/constants';
import { StateAdvertReviewCheck } from '#reviewCheck/types';

const initialState: StateAdvertReviewCheck = {
  isOpen: false,
};

const sliceAdvertReviewCheck = createSlice({
  name: REDUCER_ADVERT_REVIEW_CHECK_NAME,
  initialState,
  reducers: {
    open: (state) => {
      state.isOpen = true;
    },
    hide: (state) => {
      state.isOpen = false;
    },
  },
});

const reducerAdvertReviewCheck = sliceAdvertReviewCheck.reducer;

const {
  open: reviewCheckOpen,
  hide: reviewCheckHide,
} = sliceAdvertReviewCheck.actions;

export {
  reducerAdvertReviewCheck,
  reviewCheckOpen,
  reviewCheckHide,
};
